import { create } from "apisauce";
import getSettings from "../config/settings";
import { getAuth } from "firebase/auth";


const settings = getSettings();

const binaryClient = create({
  baseURL: settings.apiUrl,
  responseType: "blob",
});

binaryClient.addAsyncRequestTransform(async (request) => {
  let authToken;
  let userId;
  if (typeof authStorage !== "undefined") {
    authToken = await authStorage.getToken();
  } else {
    const user = getAuth().currentUser;
    if (user) {
      authToken = await user.getIdToken();
      userId = user.uid;
    }
  }
  if (!authToken) return;
  request.headers["x-auth-token"] = authToken;
  request.headers["x-auth-id"] = userId;
});

export default binaryClient;
